// extracted by mini-css-extract-plugin
module.exports = {"content":"LoginPage_content__1GUuK","footer-container":"LoginPage_footer-container__3kagg"};